import React from "react";
import styles from "./MarketInfo.module.css";
import OutputChart from "../../../assets/MarketInfoImages/OutputChart.png";
import OutputColumns from "../../../assets/MarketInfoImages/OutputColumns.png";
// ../../assets/MarketInfoImages/OutputChart.png

function MarketInfo() {
  return (
    <div className={styles.marketInfoContainer}>
      <h1 className={styles.title}>The Market</h1>
      <p className={styles.article}>
        The PropTech (Property Technology) industry is experiencing
        unprecedented growth, driven by the adoption of advanced technologies
        such as Artificial Intelligence (AI). In 2023, the global PropTech
        market was valued at approximately $27.3 billion, with a projected
        expansion to over $89.93 billion by 2032. This remarkable growth
        corresponds to a compound annual growth rate (CAGR) exceeding 15% during
        the forecast period, underscoring the transformative potential of
        technology in real estate.
      </p>
      <p className={styles.article}>
        AI innovations are at the forefront of this industry evolution,
        reshaping traditional real estate processes by enhancing efficiency,
        accuracy in property valuations, and customer service capabilities.
        These advancements have become indispensable for companies striving to
        remain competitive in an increasingly tech-driven market.
      </p>
      <p className={styles.article}>
        The integration of AI within PropTech facilitates predictive analytics,
        personalized customer experiences, and streamlined transactions,
        catering to the demands of a diverse clientele ranging from buyers and
        renters to real estate professionals and corporations. As a result, the
        PropTech industry continues to attract significant investment and
        attention from stakeholders seeking to leverage cutting-edge solutions
        in the real estate sector.
      </p>
      <div className={styles.imageContainer}>
        <img
          src={OutputChart}
          alt="Market Output Chart"
          className={styles.chartImage}
        />
        <img
          src={OutputColumns}
          alt="Market Output Columns"
          className={styles.chartImage}
        />
      </div>
      <p className={styles.sources}>
        Sources:
        <a
          href="https://www.forbes.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Forbes
        </a>
        ,
        <a
          href="https://www.growthmarketinsights.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          Growth Market Insights
        </a>
        ,
        <a
          href="https://www.fortunebusinessinsights.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          Fortune Business Insights
        </a>
      </p>
    </div>
  );
}

export default MarketInfo;
